import { supabase } from "@/integrations/supabase/client";

export interface CartSellerInfo {
  sellerId?: string;
  shopName?: string;
  shippingProfileId?: string;
  isDigital?: boolean;
}

/**
 * Fetches the seller/shipping details needed by cart items for a set of products.
 * Shop names come through the `sellers` embed, which only exposes public columns.
 */
export async function fetchCartSellerInfo(
  productIds: string[]
): Promise<Record<string, CartSellerInfo>> {
  const ids = [...new Set(productIds.filter(Boolean))];
  if (ids.length === 0) return {};

  const { data, error } = await supabase
    .from("products")
    .select("id, seller_id, shipping_profile_id, is_digital, sellers ( shop_name )")
    .in("id", ids);

  if (error || !data) {
    console.error("Failed to fetch cart seller info:", error);
    return {};
  }

  const map: Record<string, CartSellerInfo> = {};
  for (const row of data as any[]) {
    map[row.id] = {
      sellerId: row.seller_id ?? undefined,
      shopName: row.sellers?.shop_name ?? undefined,
      shippingProfileId: row.shipping_profile_id ?? undefined,
      isDigital: row.is_digital ?? undefined,
    };
  }
  return map;
}

export async function fetchCartSellerInfoForProduct(
  productId: string
): Promise<CartSellerInfo> {
  const map = await fetchCartSellerInfo([productId]);
  return map[productId] || {};
}
